class EventBus {
  constructor() {
    this.listeners = new Map()
  }

  emit(eventName, data) {
    const listeners = this.listeners.get(eventName)
    if (!listeners) {
      return
    }

    // Create a copy to avoid issues if listeners are modified during iteration
    const listenersCopy = [...listeners]
    listenersCopy.forEach(listener => {
      try {
        listener(data)
      } catch (error) {
        console.error(`Error in event listener for "${eventName}":`, error)
      }
    })
  }

  on(eventName, handler) {
    if (!this.listeners.has(eventName)) {
      this.listeners.set(eventName, new Set())
    }

    const listeners = this.listeners.get(eventName)
    listeners.add(handler)
  }

  off(eventName, handler) {
    const listeners = this.listeners.get(eventName)
    if (!listeners) {
      return
    }

    listeners.delete(handler)
    if (listeners.size === 0) {
      this.listeners.delete(eventName)
    }
  }
}

const eventBus = new EventBus()
export default eventBus
